export const getInitialState = (): any => ({
  dataProcessingProgressData: {}
});
